import type {Auth} from 'typings/portaro.be.types';

/**
 * @ngdoc type
 * @name TRole
 * @module portaro.services
 *
 * @description
 * Role name based on backend names.
 */
export type TRole =
    'ROLE_EVIDED' |
    'ROLE_READER' |
    'ROLE_LIBRARY' |
    'ROLE_SUPPLIER' |
    'ROLE_LIBRARIAN' |
    'ROLE_ADMIN' |
    'ROLE_ACTUATOR' |
    'ROLE_SERVICEMAN' |
    'ROLE_EXTERNALLY_AUTHENTICATED' |
    'ROLE_EXTERNAL_SYSTEM';

/**
 * @ngdoc service
 * @name currentAuthService
 * @module portaro.services
 *
 * @requires provider:currentAuthProvider
 *
 * @description
 * CurrentAuth operations
 */
export default class CurrentAuthService {
    public static serviceName = 'currentAuthService';

    /*@ngInject*/
    constructor(private currentAuth: Auth) {
    }

    /**
     * @ngdoc method
     * @name currentAuthService#hasRole
     *
     * @param {TRole} role Tested role.
     * @returns {boolean}
     *
     * @description
     * Has current user specified role?
     */
    public hasRole(role: TRole): boolean {
        return this.currentAuth.role.includes(role);
    }

    /**
     * @ngdoc method
     * @name currentAuthService#hasRole
     *
     * @param {...TRole} roles Tested roles
     * @returns {boolean}
     *
     * @description
     * Has current user any of specified roles?
     */
    public hasAnyRole(...roles: TRole[]): boolean {
        if (roles) {
            return roles.some((role) => this.hasRole(role));
        }
        return false;
    }
}
